// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton-module--button--3VqWK","large":"IconButton-module--large--1YH4C","cross":"IconButton-module--cross--3u2FO","crosslight":"IconButton-module--crosslight--2QXJk"};